"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var module_1 = require("./module");
var creator_ui_1 = require("@chameleoncreator/creator-ui");
exports.Back = function () {
    var _a = react_1.useContext(module_1.ModuleContext), state = _a[0], dispatch = _a[1];
    return (react_1.default.createElement("button", { onClick: function () { return dispatch(module_1.goBack()); } },
        react_1.default.createElement(creator_ui_1.BackIcon, null)));
};
exports.Back.displayName = "Back";
